import React from "react";
import PropTypes from "prop-types";
import { StaticImage } from "gatsby-plugin-image";
import UserReviewIcon from "../../../../../assets/svg/icons/user-review.inline.svg";

const UserIcon = ( { emoji } ) => {
  //we can not add dynamic src to StaticImage
  return (
   <div className="user-icon">
     {emoji ?
       <>
         {emoji === "love" && <StaticImage src={"../../../../../assets/images/withdraw/love.png"} alt={emoji}
           placeholder="blurred" width={32} quality={100}/>
         }
         {emoji === "cowboy" && <StaticImage src={"../../../../../assets/images/withdraw/cowboy.png"} alt={emoji}
                                           placeholder="blurred" width={32} quality={100}/>
         }
         {emoji === "crazy" && <StaticImage src={"../../../../../assets/images/withdraw/crazy.png"} alt={emoji}
                                             placeholder="blurred" width={32} quality={100}/>
         }
         {emoji === "devil" && <StaticImage src={"../../../../../assets/images/withdraw/devil.png"} alt={emoji}
                                             placeholder="blurred" width={32} quality={100}/>
         }
         {emoji === "smiley" && <StaticImage src={"../../../../../assets/images/withdraw/smiley.png"} alt={emoji}
                                             placeholder="blurred" width={32} quality={100}/>
         }
       </>
       : <UserReviewIcon/>}
   </div>
  );
};

export default UserIcon;

UserIcon.propTypes = {
  emoji: PropTypes.string,
};
